
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/jury",
      function () {
        return require("private-next-pages/[slug]/jury.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/jury"])
      });
    }
  